"use client";

import { Button, Typography } from "@kyan/ui";
import type { ReactNode } from "react";

import { showModal, type ShowModalOptions } from "./showModal";

export interface ConfirmOptions {
  header?: ReactNode;
  content: string | ReactNode;
  cancelText?: ReactNode;
  confirmText?: ReactNode;
  headerClassName?: string;
  onCancel?: () => void;
  onConfirm: () => void;
}

export const confirm = ({
  header = "Confirm",
  content,
  cancelText = "Cancel",
  confirmText = "Confirm",
  headerClassName,
  onCancel,
  onConfirm,
}: ConfirmOptions) => {
  const modalOptions: ShowModalOptions = {
    shouldScroll: false,
    header,
    headerClassName,
    children:
      typeof content === "string" ? (
        <Typography size={18} font="grotesk" weight="semibold">
          {content}
        </Typography>
      ) : (
        content
      ),
    footer: ({ handleClose }) => (
      <div className="mt-10 flex w-full items-center gap-4">
        <Button
          size="lg"
          className="w-1/3"
          variant="alternative"
          onClick={() => {
            onCancel?.();
            handleClose();
          }}
        >
          {cancelText}
        </Button>

        <Button
          size="lg"
          className="w-2/3"
          variant="primary"
          onClick={() => {
            onConfirm();
            handleClose();
          }}
        >
          {confirmText}
        </Button>
      </div>
    ),
  };

  showModal(modalOptions);
};
